/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Reason of lock */
export interface AccessLockDTO {
  /** @format date-time */
  lockedAt?: string;
  lockedBy?: UserDisplayDTO;
  /**
   * @minLength 0
   * @maxLength 500
   */
  lockedReason?: string;
}

export interface AddressDTO {
  /**
   * @minLength 1
   * @maxLength 100
   */
  city: string;
  companyAddress?: boolean;
  country: Country;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  deliveryInstruction?: DeliveryInstructionDTO;
  /**
   * @minLength 1
   * @maxLength 20
   */
  houseNumber: string;
  /** @format int64 */
  id?: number;
  /**
   * @minLength 1
   * @maxLength 150
   */
  street: string;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
  /**
   * @minLength 3
   * @maxLength 10
   * @pattern ^(?![A-Z]{3,})[A-Z0-9](?:[A-Z0-9\s-]*[A-Z0-9])?$
   */
  zip: string;
}

export interface AddressDisplayDTO {
  /**
   * @minLength 1
   * @maxLength 100
   */
  city: string;
  country: Country;
  /**
   * @minLength 1
   * @maxLength 20
   */
  houseNumber: string;
  /** @format int64 */
  id?: number;
  /**
   * @minLength 1
   * @maxLength 150
   */
  street: string;
  /**
   * @minLength 3
   * @maxLength 10
   * @pattern ^(?![A-Z]{3,})[A-Z0-9](?:[A-Z0-9\s-]*[A-Z0-9])?$
   */
  zip: string;
}

export interface AddressWithLegalFormDTO {
  address: AddressDTO;
  legalForm: LegalForm;
}

export interface AdminAddressDTO {
  calculationStatus?: CalculationStatus;
  /**
   * @minLength 1
   * @maxLength 100
   */
  city: string;
  companyAddress?: boolean;
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  country: Country;
  deliveryInstruction?: DeliveryInstructionDTO;
  /**
   * @minLength 1
   * @maxLength 20
   */
  houseNumber: string;
  /** @format int64 */
  id?: number;
  /**
   * @format double
   * @min -90
   * @max 90
   */
  latitude: number;
  legalForm?: LegalForm;
  /**
   * @format double
   * @min -180
   * @max 180
   */
  longitude: number;
  /** @format int64 */
  requestId?: number;
  requestNumber?: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  street: string;
  /**
   * @minLength 3
   * @maxLength 10
   * @pattern ^(?![A-Z]{3,})[A-Z0-9](?:[A-Z0-9\s-]*[A-Z0-9])?$
   */
  zip: string;
}

export interface AdminAddressWithLegalFormDTO {
  address: AdminAddressDTO;
  legalForm: LegalForm;
}

/** A single answer entry within a batch of feedback answers */
export interface AnswerRequestFeedbackEntryDTO {
  /**
   * Feedback marker ID to answer
   * @format int64
   */
  feedbackId: number;
  /**
   * Optional free text; mandatory when reason is OTHER
   * @minLength 0
   * @maxLength 1000
   */
  freeText?: string;
  /** Reason for the deactivated request not resulting in an order */
  reason: DeclineReason;
  /** Whether the reason may be shared with the affected dismissed bidders; null means do not share */
  shareWithBidder?: boolean;
}

export interface ApiTokenDTO {
  apiToken?: string;
  companyId?: string;
  /** @format date */
  expirationDate?: string;
}

/** Request body for answering a stack of PENDING feedback markers in one transaction */
export interface BatchAnswerRequestFeedbackDTO {
  /**
   * Answers to apply; must not be empty
   * @minItems 1
   */
  answers: AnswerRequestFeedbackEntryDTO[];
}

export enum CalculationStatus {
  PENDING = "PENDING",
  CALCULATED = "CALCULATED",
  ERROR = "ERROR",
}

export enum CardinalDirection {
  N = "N",
  NE = "NE",
  E = "E",
  SE = "SE",
  S = "S",
  SW = "SW",
  W = "W",
  NW = "NW",
}

export interface CartonGradeCatalogDTO {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  importedAt?: string;
  plants?: CartonGradePlantDisplayDTO[];
  values?: CartonGradeDTO;
}

export interface CartonGradeCatalogImportLogDTO {
  /** @format int32 */
  cartonGradeCount?: number;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /** @format int32 */
  createdCartonGrades?: number;
  /** @format int32 */
  createdPlants?: number;
  /** @format int32 */
  deletedCartonGrades?: number;
  /** @format int32 */
  deletedPlants?: number;
  /** @format int64 */
  downloadDuration?: number;
  errorMessage?: string;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  importDuration?: number;
  /** @format int32 */
  importTotalRows?: number;
  /** @format int32 */
  modifiedCartonGrades?: number;
  /** @format int32 */
  modifiedPlants?: number;
  /** @format int32 */
  plantCount?: number;
  success?: boolean;
}

export interface CartonGradeDTO {
  /**
   * @minLength 4
   * @maxLength 15
   */
  code: string;
  /**
   * @min 1
   * @max 200
   */
  edgeCrushTest: number;
  /**
   * @minLength 1
   * @maxLength 8
   */
  flute: string;
  /**
   * @minLength 3
   * @maxLength 12
   */
  fluteOne: string;
  /**
   * @minLength 0
   * @maxLength 13
   */
  fluteThree?: string;
  /**
   * @minLength 0
   * @maxLength 12
   */
  fluteTwo?: string;
  /**
   * @minLength 3
   * @maxLength 12
   */
  innerLiner: string;
  /**
   * @minLength 0
   * @maxLength 12
   */
  linerOne?: string;
  /**
   * @minLength 0
   * @maxLength 12
   */
  linerTwo?: string;
  /**
   * @minLength 3
   * @maxLength 12
   */
  outerLiner: string;
  /**
   * @min 0.01
   * @max 1000
   */
  weight: number;
  wetStrength?: boolean;
}

export interface CartonGradePlantDisplayDTO {
  /** @format int64 */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 100
   */
  location?: string;
  /**
   * @minLength 0
   * @maxLength 1
   */
  materialProductionPriorityCode: string;
  /**
   * @minLength 0
   * @maxLength 10
   */
  name: string;
}

export interface ChangeEmailDTO {
  /**
   * @format email
   * @minLength 4
   * @maxLength 320
   */
  email: string;
}

export interface ChangePasswordDTO {
  newPassword: string;
  newPasswordRepeat: string;
  oldPassword: string;
}

/** A chat channel with its timeline */
export interface ChatDTO {
  canMarkRead?: boolean;
  canWrite?: boolean;
  companyA?: CompanyDisplayDTO;
  companyB?: CompanyDisplayDTO;
  displayName?: string;
  forCompany?: CompanyDisplayDTO;
  /** @format int64 */
  id?: number;
  /**
   * Timestamp of the supplier's first view of the request's message area; filled in the buyer and operator view, null in the supplier view
   * @format date-time
   */
  supplierViewedAt?: string | null;
  timeline?: (MessageEntry | StatusPillEntry)[];
  type?: ChatType;
  /** @format int32 */
  unreadCount?: number;
}

/** Metadata for a chat message attachment */
export interface ChatMessageAttachmentMetadataDTO {
  contentType?: string;
  filename?: string;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  sizeBytes?: number;
}

/** A single message in the chat timeline */
export interface ChatMessageDTO {
  /** List of attachments (0 to 5 items) */
  attachments?: ChatMessageAttachmentMetadataDTO[];
  author?: UserDisplayDTO;
  authorCompany?: CompanyDisplayDTO;
  body?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format int64 */
  id?: number;
  kind?: MessageKind;
  /** Whether this message has been read by the recipient company; always true for own messages and SYSTEM_NOTEs */
  read?: boolean;
  /** Read state for all active users of the recipient's company — empty list for own messages and SYSTEM_NOTEs. */
  readBy?: MessageReadByUserDTO[];
}

/** A single entry in the chat timeline — either a message or a status pill */
export interface ChatTimelineEntryDTO {
  type: string;
}

export enum ChatType {
  SYSTEM = "SYSTEM",
  ONE_TO_ONE = "ONE_TO_ONE",
}

export interface CollaborationByMonthDTO {
  /** @format int32 */
  month?: number;
  /** @format int64 */
  quoteCount?: number;
  /** @format int64 */
  requesterCompanyId?: number;
  requesterCompanyName?: string;
  /** @format int64 */
  supplierCompanyId?: number;
  supplierCompanyName?: string;
  /** @format int32 */
  year?: number;
}

export interface CollaborationSummaryDTO {
  /** @format int64 */
  quoteCount?: number;
  /** @format int64 */
  requesterCompanyId?: number;
  requesterCompanyName?: string;
  /** @format int64 */
  supplierCompanyId?: number;
  supplierCompanyName?: string;
}

export enum CompanyActions {
  ADD_USER = "ADD_USER",
  CONFIRM_COMPANY_REGISTRATION = "CONFIRM_COMPANY_REGISTRATION",
  REJECT_COMPANY_REGISTRATION = "REJECT_COMPANY_REGISTRATION",
  LOCK_COMPANY = "LOCK_COMPANY",
  UNLOCK_COMPANY = "UNLOCK_COMPANY",
  TERMINATE_COMPANY = "TERMINATE_COMPANY",
  CANCEL_COMPANY_TERMINATION = "CANCEL_COMPANY_TERMINATION",
  REACTIVATE_COMPANY = "REACTIVATE_COMPANY",
  ARCHIVE_COMPANY = "ARCHIVE_COMPANY",
  DELETE_COMPANY = "DELETE_COMPANY",
  RESEND_INVITATION = "RESEND_INVITATION",
  GENERATE_COMPANY_SIGNUP_LINK = "GENERATE_COMPANY_SIGNUP_LINK",
}

export interface CompanyDTO {
  additionalInformation?: string;
  addresses?: AddressDTO[];
  /** @uniqueItems true */
  allowedActions?: CompanyActions[];
  bankName?: string;
  bic?: string;
  commercialRegistrationNumber?: string;
  companyAddress?: AddressDTO;
  contactPerson?: UserDisplayDTO;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  deliveryHours?: string;
  erpManufacturer?: string;
  erpSoftwareName?: string;
  erpSoftwareVersion?: string;
  iban?: string;
  /** @format int64 */
  id?: number;
  invitation?: InvitationInfoDTO;
  legalForm?: LegalForm;
  /** Reason of lock */
  lock?: AccessLockDTO;
  managingDirector?: UserDisplayDTO;
  maschineryFleet?: MaschineryFleetDTO;
  name?: string;
  /** @format int32 */
  number?: number;
  officeHours?: string;
  paymentTerms?: string;
  status?: CompanyStatus;
  tenant?: TenantDisplayDTO;
  /** Reason of termination */
  termination?: CompanyTerminationDTO;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  users?: UserDisplayDTO[];
  vatIdentificationNumber?: string;
  /** @format int32 */
  version?: number;
  website?: string;
}

export interface CompanyDisplayDTO {
  additionalInformation?: string;
  companyAddress?: AddressDisplayDTO;
  companyRelationships?: CompanyRelationshipDto;
  /** @format int64 */
  id?: number;
  locked?: boolean;
  managingDirector?: string;
  /** @format int64 */
  managingDirectorId?: number;
  name?: string;
  /** @format int32 */
  number?: number;
  paymentTerms?: string;
  status?: CompanyStatus;
  tenant?: TenantDisplayDTO;
}

export interface CompanyInvitationDTO {
  /**
   * @minLength 2
   * @maxLength 150
   */
  companyName: string;
  /**
   * @minLength 4
   * @maxLength 320
   * @pattern ^[a-zA-Z0-9_%+-](?:[a-zA-Z0-9_%+-]|\.(?=[a-zA-Z0-9_%+-]))*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  firstName: string;
  invitationToken?: string;
  language: Language;
  /**
   * @minLength 2
   * @maxLength 100
   */
  lastName: string;
  salutation: Salutation;
  /** @format int64 */
  tenantId?: number;
}

export enum CompanyMembershipStatus {
  INVITED = "INVITED",
  INVITED_LOCKED = "INVITED_LOCKED",
  CONFIRMED = "CONFIRMED",
  CONFIRMED_LOCKED = "CONFIRMED_LOCKED",
  DEACTIVATED = "DEACTIVATED",
}

export interface CompanyOptionDTO {
  /** @format int64 */
  id?: number;
  name?: string;
}

export interface CompanyOverviewRowDTO {
  /** @uniqueItems true */
  allowedActions?: CompanyActions[];
  company?: CompanyDisplayDTO;
  /** @format int32 */
  countOfAcceptedQuotes?: number;
  /** @format int32 */
  countOfBidderInteractions?: number;
  /** @format int32 */
  countOfBidderRejections?: number;
  /** @format int32 */
  countOfConfirmedRequests?: number;
  /** @format int32 */
  countOfPublishedQuotes?: number;
  /** @format int32 */
  countOfPublishedRequests?: number;
  /** @format int64 */
  id?: number;
  /** @format date-time */
  lastLoginAt?: string;
  lastLoginUserName?: string;
  /** @format date-time */
  statusDate?: string;
  statusEvents?: CompanyStatusEventDTO[];
  tenantName?: string;
}

export enum CompanyRelationshipActions {
  WHITELIST = "WHITELIST",
  BLACKLIST = "BLACKLIST",
  DESIRED_WHITELIST = "DESIRED_WHITELIST",
  WITHDRAW_DESIRED_WHITELIST = "WITHDRAW_DESIRED_WHITELIST",
}

export interface CompanyRelationshipDto {
  /** @uniqueItems true */
  allowedActions?: CompanyRelationshipActions[];
  currentStatus?: CompanyRelationshipStatus;
  desiredStatus?: CompanyRelationshipStatus;
  /** @format date */
  effectiveAt?: string;
  /** @format date-time */
  requestedAt?: string;
  /** @format int64 */
  sourceCompanyId?: number;
  sourceCompanyName?: string;
  /** @format int64 */
  targetCompanyId?: number;
  targetCompanyName?: string;
}

/** Filter criteria for company relationships */
export interface CompanyRelationshipFilterDto {
  /** Name of the target company (substring) */
  companyName?: string;
  /** Country of target company */
  country?: Country;
  /** Relationship status (Whitelist/Blacklist) */
  status?: CompanyRelationshipStatus;
}

/** Response DTO for company relationships */
export interface CompanyRelationshipResponseDto {
  /** List of companies with their relationships */
  companyWithRelationshipDTOS?: CompanyWithRelationshipDTO[];
  /**
   * Current page
   * @format int32
   */
  page?: number;
  /**
   * Number of items per page
   * @format int32
   */
  size?: number;
  /**
   * Total number of elements
   * @format int64
   */
  totalElements?: number;
  /**
   * Total number of pages
   * @format int32
   */
  totalPages?: number;
}

export enum CompanyRelationshipStatus {
  WHITELIST = "WHITELIST",
  BLACKLIST = "BLACKLIST",
}

export interface CompanySearchParamsDTO {
  companyName?: string;
  status?: CompanyStatus[];
}

export interface CompanySignUpDTO {
  /**
   * @minLength 0
   * @maxLength 500
   */
  additionalInformation?: string;
  /**
   * @minLength 3
   * @maxLength 100
   */
  bankName: string;
  /**
   * @minLength 8
   * @maxLength 11
   * @pattern ^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$
   */
  bic: string;
  ceo: boolean;
  /**
   * @minLength 1
   * @maxLength 100
   */
  city: string;
  /**
   * @minLength 4
   * @maxLength 20
   * @pattern ^(?:$|[A-Za-z0-9](?:[A-Za-z0-9\/\-\.\s]*[A-Za-z0-9])?)$
   */
  commercialRegisterNumber?: string;
  /**
   * @minLength 2
   * @maxLength 150
   */
  companyName: string;
  confidentialityAccepted: boolean;
  confirmPassword?: string;
  contractAndUsageAccepted: boolean;
  country: Country;
  dieCutting: boolean;
  digitalPrinting: boolean;
  /**
   * @minLength 4
   * @maxLength 320
   * @pattern ^[a-zA-Z0-9_%+-](?:[a-zA-Z0-9_%+-]|\.(?=[a-zA-Z0-9_%+-]))*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  erpManufacturer: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  erpSoftwareName: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  erpSoftwareVersion: string;
  /**
   * @minLength 6
   * @maxLength 20
   * @pattern ^(?=(?:\D*\d){6,})(?:\+|00)?[1-9]\d{0,2}[-\.\s]?\(?\d+\)?(?:[-\.\s]\(?\d+\)?)*$
   */
  fax?: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  firstName: string;
  flexoPrinting: boolean;
  folderGluerMachine: boolean;
  hazardousGoodsQualification: boolean;
  hdFlexoPrinting: boolean;
  /**
   * @minLength 1
   * @maxLength 20
   */
  houseNumber: string;
  /**
   * @minLength 3
   * @maxLength 34
   * @pattern ^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$
   */
  iban: string;
  language: Language;
  /**
   * @minLength 2
   * @maxLength 100
   */
  lastName: string;
  legalForm: LegalForm;
  maxiliner: boolean;
  midliner: boolean;
  miniliner: boolean;
  /**
   * @minLength 1
   * @maxLength 250
   */
  officeHours: string;
  offsetPrinting: boolean;
  packaging: boolean;
  password?: string;
  /**
   * @minLength 1
   * @maxLength 512
   */
  paymentTerms: string;
  /**
   * @minLength 6
   * @maxLength 20
   * @pattern ^(?=(?:\D*\d){6,})(?:\+|00)?[1-9]\d{0,2}[-\.\s]?\(?\d+\)?(?:[-\.\s]\(?\d+\)?)*$
   */
  phone: string;
  /**
   * @minLength 3
   * @maxLength 10
   * @pattern ^(?![A-Z]{3,})[A-Z0-9](?:[A-Z0-9\s-]*[A-Z0-9])?$
   */
  postalCode: string;
  privacyPolicyAccepted: boolean;
  salutation: Salutation;
  /**
   * @minLength 1
   * @maxLength 150
   */
  streetAddress: string;
  userAlreadyRegistered?: boolean;
  /**
   * @minLength 8
   * @maxLength 20
   * @pattern ^([A-Z]{2}(?!.*[A-Z]{7,})[A-Z0-9]+|CHE-\d{3}\.\d{3}\.\d{3})$
   */
  vatId: string;
  /**
   * @minLength 3
   * @maxLength 256
   * @pattern ^(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,10}(:\d{1,5})?(\/\S*)?$
   */
  website?: string;
}

export interface CompanyStatisticsDTO {
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  /** @format int64 */
  numberOfAcceptedQuotes?: number;
  /** @format int64 */
  numberOfActiveUsers?: number;
  /** @format int64 */
  numberOfConfirmedRequests?: number;
  /** @format int64 */
  numberOfCreatedRequests?: number;
  /** @format int64 */
  numberOfPublishedRequests?: number;
  /** @format int64 */
  numberOfRejectedQuotes?: number;
  /** @format int64 */
  numberOfSubmittedQuotes?: number;
  /** @format int64 */
  numberOfToBeConfirmedRequests?: number;
  /** @format int64 */
  numberOfUsers?: number;
}

export enum CompanyStatus {
  OPERATOR = "OPERATOR",
  INVITED = "INVITED",
  UNVERIFIED = "UNVERIFIED",
  CONFIRMED = "CONFIRMED",
  CONFIRMED_LOCKED = "CONFIRMED_LOCKED",
  TERMINATION_RECEIVED = "TERMINATION_RECEIVED",
  TERMINATION_RECEIVED_LOCKED = "TERMINATION_RECEIVED_LOCKED",
  TERMINATED = "TERMINATED",
  REJECTED = "REJECTED",
  ARCHIVED = "ARCHIVED",
}

export interface CompanyStatusEventDTO {
  actorName?: string;
  automatic?: boolean;
  /** @format date-time */
  occurredAt?: string;
  type?: CompanyStatusEventType;
}

export enum CompanyStatusEventType {
  INVITED = "INVITED",
  REGISTERED = "REGISTERED",
  CONFIRMED = "CONFIRMED",
  TERMINATED = "TERMINATED",
}

/** Company Tenant */
export interface CompanyTenant {
  /** Company information */
  company: CompanyDisplayDTO;
  /** Contact person of the company */
  contactPerson: UserDisplayDTO;
}

/** Reason of termination */
export interface CompanyTerminationDTO {
  /** @format date-time */
  requestAt?: string;
  requestBy?: UserDisplayDTO;
  /** @format date */
  requestExecDate: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  requestReason: string;
  requestSource: TerminationSource;
}

export interface CompanyWithRelationshipDTO {
  companyAddress?: AddressDisplayDTO;
  relationship?: CompanyRelationshipDto;
  /** @format int64 */
  targetCompanyId?: number;
  targetCompanyName?: string;
  /** @format int64 */
  targetTenantId?: number;
  targetTenantName?: string;
}

export interface ConfirmRequestInternallyDTO {
  /**
   * @minLength 0
   * @maxLength 1000
   */
  reason: string;
}

/** Full conversation for a request with all visible chats */
export interface ConversationDTO {
  chats?: ChatDTO[];
  /** @format int64 */
  id?: number;
  /** @format int64 */
  requestId?: number;
}

export interface CopyEmailSettingsResult {
  updatedCompanies: CopyEmailSettingsTarget[];
}

export interface CopyEmailSettingsTarget {
  /** @format int64 */
  companyId: number;
  companyName: string;
}

export enum Country {
  GERMANY = "GERMANY",
  NETHERLANDS = "NETHERLANDS",
  AUSTRIA = "AUSTRIA",
  SWITZERLAND = "SWITZERLAND",
  CZECHIA = "CZECHIA",
  POLAND = "POLAND",
  ITALY = "ITALY",
  FRANCE = "FRANCE",
}

/** Request body for creating a new chat message */
export interface CreateChatMessageDTO {
  /**
   * @minLength 0
   * @maxLength 4000
   */
  body?: string;
}

export enum DeclineReason {
  EXTERNAL_TENDER_NOT_AWARDED = "EXTERNAL_TENDER_NOT_AWARDED",
  END_CUSTOMER_REQUIREMENTS_CHANGED = "END_CUSTOMER_REQUIREMENTS_CHANGED",
  AWARDED_OFF_PLATFORM = "AWARDED_OFF_PLATFORM",
  IN_HOUSE_PRODUCTION = "IN_HOUSE_PRODUCTION",
  PRICE_NOT_COMPETITIVE = "PRICE_NOT_COMPETITIVE",
  NO_REASON_GIVEN = "NO_REASON_GIVEN",
  OTHER = "OTHER",
  AWARDED_TO_OTHER_SUPPLIER = "AWARDED_TO_OTHER_SUPPLIER",
}

export interface DeliveryInstructionDTO {
  address?: AddressDTO;
  /**
   * @minLength 0
   * @maxLength 100
   */
  arrivalNotification?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  fridayInstruction?: string;
  /** @format int64 */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 100
   */
  mondayInstruction?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  saturdayInstruction?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  sundayInstruction?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  thursdayInstruction?: string;
  timeSlotBookingRequired?: boolean;
  /**
   * @minLength 0
   * @maxLength 100
   */
  tuesdayInstruction?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  wednesdayInstruction?: string;
}

export interface DimensionDTO {
  /** @format int32 */
  height?: number;
  /** @format int32 */
  length?: number;
  /** @format int32 */
  width?: number;
}

/** Request body for manually declining a quote with a structured reason */
export interface DismissQuoteDTO {
  /** Structured reason why the quote is declined */
  declineReason: DeclineReason;
  /**
   * Optional explanation; mandatory when declineReason is OTHER
   * @minLength 0
   * @maxLength 1000
   */
  freeText?: string;
}

export interface ErrorDTO {
  errors?: Record<string, string>;
  message?: string;
  /** @format int32 */
  status?: number;
}

/** Standard API error response wrapper */
export interface ErrorResponse {
  error?: ErrorDTO;
}

/** A single request expiring within the configurable validity-reminder window */
export interface ExpiringSoonRequestDTO {
  /**
   * Buyer company number
   * @format int32
   */
  companyNumber?: number;
  /** Customer reference number */
  customerReferenceNumber?: string;
  /**
   * Request ID
   * @format int64
   */
  id?: number;
  /**
   * Expiry date of the request
   * @format date
   */
  validUntil?: string;
}

export interface ExtendRequestDatesDTO {
  /** @format date */
  deliveryDateFrom: string;
  /** @format date */
  deliveryDateTo: string;
  /** @format date */
  validUntil: string;
}

export interface FefcoCodeDTO {
  code?: string;
  /** @format int64 */
  id?: number;
}

export interface I18NImportFindingDTO {
  key?: string;
  message?: string;
  /** @format int32 */
  rowNumber?: number;
  severity?: "ERROR" | "WARNING";
}

export interface I18NImportLogDTO {
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /** @format int32 */
  entryCount?: number;
  findings?: I18NImportFindingDTO[];
  /** @format int64 */
  id?: number;
  language?: Language;
  success?: boolean;
  /** @format int32 */
  warningCount?: number;
}

export interface I18NLanguageStatusDTO {
  /** @format int64 */
  deviatingFromBaselineCount?: number;
  /** @format int64 */
  entryCount?: number;
  language?: Language;
  /** @format date-time */
  lastContentChangeAt?: string;
  lastContentChangeServerVersion?: string;
  lastImport?: I18NImportLogDTO;
  maintained?: boolean;
}

export interface InvitationInfoDTO {
  expired?: boolean;
  /** @format date-time */
  invitedAt?: string;
  /** @format date-time */
  lastInvitationAt?: string;
  /** @format date */
  validUntil?: string;
}

export enum Language {
  GERMAN = "GERMAN",
  ENGLISH = "ENGLISH",
  POLISH = "POLISH",
  ITALIAN = "ITALIAN",
  FRENCH = "FRENCH",
  CZECH = "CZECH",
}

export enum LegalDocument {
  IMPRINT = "IMPRINT",
  COOKIE_POLICY = "COOKIE_POLICY",
  CONTRACT_CONCEPT = "CONTRACT_CONCEPT",
  PRIVACY_POLICY = "PRIVACY_POLICY",
  TERMS_AND_CONDITIONS = "TERMS_AND_CONDITIONS",
}

export interface LegalDocumentDTO {
  content?: string;
  document?: LegalDocument;
  effectiveLanguage?: Language;
  requestedLanguage?: Language;
}

export enum LegalForm {
  AG = "AG",
  AG_KG = "AG_KG",
  AGCoKGaA = "AG_Co_KGaA",
  AGCoOHG = "AG_Co_OHG",
  GAG = "gAG",
  GbR = "GbR",
  GmbH = "GmbH",
  GmbHCoKG = "GmbH_Co_KG",
  GmbHCoKGaA = "GmbH_Co_KGaA",
  GmbHCoOHG = "GmbH_Co_OHG",
  GmbHG = "GmbHG",
  KG = "KG",
  KGaA = "KGaA",
  KGaACoKG = "KGaA_Co_KG",
  OHG = "OHG",
  OHGMbh = "OHG_mbh",
  PartG = "PartG",
  PartGMbB = "PartG_mbB",
  Sonstige = "Sonstige",
  StiftungCoKG = "Stiftung_Co_KG",
  UGH = "UG_h",
  UGHCoKG = "UG_hCo_KG",
  SE = "SE",
  Einzelunternehmer = "Einzelunternehmer",
  EingetragenesUnternehmen = "Eingetragenes_Unternehmen",
  BeslotenVennootschap = "Besloten_Vennootschap",
  NaamlozeVennootschap = "Naamloze_Vennootschap",
  VennootschapOnderFirma = "Vennootschap_Onder_Firma",
  CommanditaireVennootschap = "Commanditaire_Vennootschap",
  Maatschap = "Maatschap",
  Eenmanszaak = "Eenmanszaak",
  CHKollektivgesellschaft = "CH_Kollektivgesellschaft",
  CHKommanditgesellschaft = "CH_Kommanditgesellschaft",
  CHEinzelunternehmen = "CH_Einzelunternehmen",
  CHGenossenschaft = "CH_Genossenschaft",
  CZSRO = "CZ_s_r_o",
  CZAS = "CZ_a_s",
  CZKS = "CZ_k_s",
  CZVOS = "CZ_v_o_s",
  CZDruzstvo = "CZ_Druzstvo",
  CZ_OSVC = "CZ_OSVC",
  PLSpZOO = "PL_Sp_z_o_o",
  PL_S_A = "PL_S_A",
  PLSpK = "PL_Sp_k",
  PLSpJ = "PL_Sp_j",
  PLSpP = "PL_Sp_p",
  PL_PSA = "PL_PSA",
  PL_JDG = "PL_JDG",
  ITSRL = "IT_S_r_l",
  ITSRLS = "IT_S_r_l_s",
  ITSPA = "IT_S_p_A",
  ITSAPA = "IT_S_a_p_A",
  ITSNC = "IT_S_n_c",
  ITSAS = "IT_S_a_s",
  ITSocCoop = "IT_Soc_coop",
  ITDittaIndividuale = "IT_Ditta_individuale",
  FR_SARL = "FR_SARL",
  FR_EURL = "FR_EURL",
  FR_SAS = "FR_SAS",
  FR_SASU = "FR_SASU",
  FR_SA = "FR_SA",
  FR_SNC = "FR_SNC",
  FR_SCS = "FR_SCS",
  FR_SCA = "FR_SCA",
  FR_EI = "FR_EI",
}

export interface LinkGenerationResponse {
  url?: string;
  /** @format date */
  validUntil?: string;
}

export interface LogDTO {
  file?: string;
  files?: string[];
  /** @format int32 */
  limit?: number;
  lines?: LogEntryDTO[];
  /** @format int64 */
  offset?: number;
  /** @format int64 */
  totalLines?: number;
}

export interface LogEntryDTO {
  exceptionClass?: string;
  /** @format int32 */
  id?: number;
  level?: string;
  logger?: string;
  mdc?: Record<string, string>;
  message?: string;
  stackTrace?: string;
  thread?: string;
  /** @format date-time */
  timestamp?: string;
}

export interface MailDTO {
  bcc?: string[];
  cc?: string[];
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  from?: string;
  /** @format int64 */
  id?: number;
  message?: string;
  receiver?: CompanyDisplayDTO;
  sender?: CompanyDisplayDTO;
  /** @format date-time */
  sent?: string;
  status?: MailStatus;
  subject?: string;
  to?: string[];
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export interface MailHistoryDTO {
  mails?: MailDTO[];
}

export enum MailStatus {
  SENT = "SENT",
  NOT_SENT = "NOT_SENT",
  ERROR = "ERROR",
}

export interface MaschineryFleetDTO {
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  dieCutting?: boolean;
  digitalPrinting?: boolean;
  flexoPrinting?: boolean;
  folderGluerMachine?: boolean;
  hazardousGoodsQualification?: boolean;
  hdFlexoPrinting?: boolean;
  /** @format int64 */
  id?: number;
  maxiliner?: boolean;
  midliner?: boolean;
  miniliner?: boolean;
  offsetPrinting?: boolean;
  packaging?: boolean;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export interface MatomoConfigDTO {
  siteId?: string;
  url?: string;
}

export type MessageEntry = ChatTimelineEntryDTO & {
  /** A single message in the chat timeline */
  message?: ChatMessageDTO;
};

export enum MessageKind {
  USER_MESSAGE = "USER_MESSAGE",
  SYSTEM_NOTE = "SYSTEM_NOTE",
}

/** Read status of a single user for a specific chat message */
export interface MessageReadByUserDTO {
  name?: string;
  /**
   * Timestamp when the user read the message; null means unread
   * @format date-time
   */
  readAt?: string | null;
  /** @format int64 */
  userId?: number;
}

export enum NumberOfPallet {
  ONE_ON_THE_SIDE = "ONE_ON_THE_SIDE",
  ONE_ON_THE_LONG_AND_SHORT_SIDE = "ONE_ON_THE_LONG_AND_SHORT_SIDE",
  ON_ALL_FOUR_SIDES = "ON_ALL_FOUR_SIDES",
}

/** The oldest still-open (PENDING) feedback marker for the current company */
export interface OpenRequestFeedbackDTO {
  /**
   * Buyer company number
   * @format int32
   */
  companyNumber?: number;
  /** Customer reference number */
  customerReferenceNumber?: string;
  /**
   * Feedback marker ID
   * @format int64
   */
  feedbackId?: number;
  /**
   * Request ID
   * @format int64
   */
  requestId?: number;
  /**
   * Expiry date of the request
   * @format date
   */
  validUntil?: string;
}

export enum OrderActions {
  ADVANCE_STATUS = "ADVANCE_STATUS",
  EDIT_DELIVERY_DATE = "EDIT_DELIVERY_DATE",
  CONFIRM_DELIVERY_DATE = "CONFIRM_DELIVERY_DATE",
  REJECT_DELIVERY_DATE = "REJECT_DELIVERY_DATE",
  CANCEL_ORDER = "CANCEL_ORDER",
  SEND_CHAT_MESSAGE = "SEND_CHAT_MESSAGE",
  VIEW_CHAT = "VIEW_CHAT",
}

export interface OrderCancellationDTO {
  /**
   * @minLength 0
   * @maxLength 1000
   */
  cancellationReason: string;
}

export interface OrderDTO {
  /** @uniqueItems true */
  allowedActions?: OrderActions[];
  cancellationReason?: string;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /** @format date */
  deliveryDate?: string;
  deliveryDateRejectionReason?: string;
  /** @format int64 */
  id?: number;
  /** @format date */
  maxDeliveryDate?: string;
  orderNumber?: string;
  /** @format int64 */
  quoteId?: number;
  /** @format int64 */
  requestId?: number;
  requestStatus?: RequestStatus;
  status?: OrderStatus;
  /** @format date */
  statusDate?: string;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export interface OrderDataDTO {
  allowPalletOverhang?: boolean;
  /**
   * @format int32
   * @min 0
   * @max 50
   */
  bundlesPerPackage?: number;
  cartonGrade: CartonGradeDTO;
  /** @format date-time */
  cartonGradeCopiedFromCatalogAt?: string;
  clicheCosts?: number;
  contractGluing?: boolean;
  counterPallets?: boolean;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  dangerousGoods?: boolean;
  /** @format date */
  deliveryDateFrom?: string;
  /** @format date */
  deliveryDateTo?: string;
  /** @format int32 */
  externalNumberOfColors?: number;
  externalPrint?: PrintType;
  /**
   * @minLength 0
   * @maxLength 50
   */
  fefcoCode?: string;
  glued?: boolean;
  /** @format int64 */
  id?: number;
  /**
   * @format int32
   * @min 1
   * @max 5000
   */
  internalDimensionHeight: number;
  /**
   * @format int32
   * @min 1
   * @max 5000
   */
  internalDimensionLength: number;
  /**
   * @format int32
   * @min 1
   * @max 5000
   */
  internalDimensionWidth: number;
  /** @format int32 */
  internalNumberOfColors?: number;
  internalPrint?: PrintType;
  numberOfPalletLabel?: NumberOfPallet;
  palletExchange?: boolean;
  /**
   * @format int32
   * @min 150
   * @max 2400
   */
  palletHeight?: number;
  palletLabelNeutral?: boolean;
  /** @format int32 */
  palletOverhang?: number;
  palletType: PalletType;
  palletizingFixed?: boolean;
  /**
   * @minLength 0
   * @maxLength 512
   */
  paymentTerms?: string;
  /**
   * @min 0
   * @max 99.99
   */
  pricePerPallet?: number;
  /** @format int32 */
  quantityOptionSelected?: number;
  /**
   * @maxItems 5
   * @minItems 1
   */
  quantityOptions: QuantityOptionDTO[];
  /**
   * @format int32
   * @min 0
   * @max 99999
   */
  quantityPerPallet?: number;
  rfi?: boolean;
  separateExtraCosts?: boolean;
  seriesOrder?: boolean;
  /**
   * @format int32
   * @min 1
   * @max 100000000
   */
  seriesTotalQuantity?: number;
  siliconeTape: boolean;
  stitched?: boolean;
  stretching?: boolean;
  taped?: boolean;
  tearTape: boolean;
  toolingCosts?: number;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export interface OrderDeliveryDateRejectionDTO {
  /**
   * @minLength 0
   * @maxLength 1000
   */
  reason?: string;
}

export interface OrderDeliveryDateUpdateDTO {
  /** @format date */
  deliveryDate: string;
}

export interface OrderDocumentDTO {
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  filenName?: string;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  size?: number;
  type?: OrderDocumentType;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export enum OrderDocumentType {
  BLUE_PRINT = "BLUE_PRINT",
  PRINT_IMAGE = "PRINT_IMAGE",
}

export interface OrderDocumentsDTO {
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  documents?: OrderDocumentDTO[];
  /** @format int64 */
  id?: number;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export enum OrderFilter {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
  NEUTRAL = "NEUTRAL",
}

export interface OrderOverviewRowDTO {
  deliveryAddress?: AddressDisplayDTO;
  /** @format date */
  deliveryDate?: string;
  /** @format date */
  deliveryDateFrom?: string;
  /** @format date */
  deliveryDateTo?: string;
  externalReferenceNumber?: string;
  /** @format int64 */
  id?: number;
  myReferenceNumber?: string;
  /** @format int32 */
  oneToOneUnreadCount?: number;
  orderNumber?: string;
  quoteReferenceNumber?: string;
  /** @format int64 */
  requestId?: number;
  requesterCompanyName?: string;
  status?: OrderStatus;
  supplierCompanyName?: string;
}

/** Search parameters for the paged order overview */
export interface OrderSearchParamsDTO {
  /**
   * Company to restrict the result to. Effective for operators only; every other caller is restricted to its own company.
   * @format int64
   */
  companyId?: number;
  /**
   * Earliest accepted confirmed delivery date. Unlike the planned period this is a single date that has to fall into the range, so an order without a confirmed delivery date drops out as soon as one of the two bounds is set. Omitting the bound leaves it open.
   * @format date
   */
  confirmedDeliveryDateFrom?: string;
  /**
   * Latest accepted confirmed delivery date. An order without a confirmed delivery date drops out as soon as one of the two bounds is set. Omitting the bound leaves it open.
   * @format date
   */
  confirmedDeliveryDateTo?: string;
  /**
   * Substring compared against the delivery address' street, house number, postal code and city separately, exactly the four parts the free-text search covers. It does not compare against the rendered single line, since formatAddressToSingleLine composes that line language-dependently, and the country name stays out for the same reason it stays out of the free-text search. Case is irrelevant, blank means no restriction.
   * @minLength 0
   * @maxLength 150
   */
  deliveryAddressContains?: string;
  /** True requires an unread ONE_TO_ONE chat message of the logged-in user (System-Chat excluded), false requires none, omitted means no restriction. An Innendienst-Mitarbeiter never has unread messages, so true returns nothing for that caller. */
  hasUnreadMessages?: boolean;
  /**
   * Substring of the order number. Case is irrelevant, blank means no restriction.
   * @minLength 0
   * @maxLength 150
   */
  orderNumberContains?: string;
  /**
   * Selected order statuses. An empty list is a selection of nothing and yields an empty result; it does not mean all statuses.
   * @maxItems 500
   * @minItems 0
   */
  orderStatuses?: OrderStatus[];
  /**
   * Zero-based page index
   * @format int32
   * @min 0
   * @default 0
   */
  page?: number;
  /**
   * Start of the window the planned delivery period must overlap. The period is an interval, so the filter matches whenever it ends no earlier than this date — a single shared day is already a hit. Omitting the bound leaves it open.
   * @format date
   */
  plannedDeliveryFrom?: string;
  /**
   * End of the window the planned delivery period must overlap. The filter matches whenever the period begins no later than this date. Omitting the bound leaves it open.
   * @format date
   */
  plannedDeliveryTo?: string;
  /**
   * Substring of the composed quote number. Case is irrelevant, blank means no restriction.
   * @minLength 0
   * @maxLength 150
   */
  quoteNumberContains?: string;
  /**
   * Free-text search over the rendered text columns: order number, composed quote number and delivery address (street, house number, postal code, city); in the NEUTRAL view additionally the requester's and the supplier's company name. Case is irrelevant, percent signs and underscores count as searched characters. An empty or blank term is no restriction. Status labels and the country name are not searchable — both live language-dependent in the i18n runtime store and have no comparable column. The order's own text columns additionally carry a column filter of their own: orderNumberContains, quoteNumberContains and deliveryAddressContains, one per column header.
   * @minLength 0
   * @maxLength 150
   */
  searchText?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 50
   * @default 25
   */
  size?: number;
  /**
   * Sort direction. It takes effect together with a picked sortField only; without a column the fixed default order applies and the direction is ignored.
   * @default "ASC"
   */
  sortDirection?: OrderSortDirection;
  /** Column to sort by. Omitting the field yields the default order: the running orders first and the cancelled and deactivated ones last, within each group the start of the planned delivery period ascending. Sending PLANNED_DELIVERY_PERIOD explicitly is the user-picked column sort instead, which orders by that column alone. REQUESTER_COMPANY and SUPPLIER_COMPANY exist in the NEUTRAL view only and are rejected elsewhere. */
  sortField?: OrderSortField;
  /** Perspective of the search: requester (INTERNAL), supplier (EXTERNAL) or the operator-only platform-wide view (NEUTRAL) */
  type: OrderFilter;
}

/** One page of the order overview including the total hit count */
export interface OrderSearchResultDTO {
  /**
   * Zero-based index of the returned page
   * @format int32
   */
  page?: number;
  /** Rows of the returned page */
  rows?: OrderOverviewRowDTO[];
  /**
   * Requested page size
   * @format int32
   */
  size?: number;
  /**
   * Number of hits across all pages
   * @format int64
   */
  totalElements?: number;
  /**
   * Number of pages for the current page size
   * @format int32
   */
  totalPages?: number;
  /**
   * Sum of unread messages over the whole filtered set, not just the returned page
   * @format int32
   */
  totalUnreadMessages?: number;
}

export enum OrderSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum OrderSortField {
  ORDER_NUMBER = "ORDER_NUMBER",
  QUOTE_NUMBER = "QUOTE_NUMBER",
  STATUS = "STATUS",
  DELIVERY_ADDRESS = "DELIVERY_ADDRESS",
  PLANNED_DELIVERY_PERIOD = "PLANNED_DELIVERY_PERIOD",
  CONFIRMED_DELIVERY_DATE = "CONFIRMED_DELIVERY_DATE",
  REQUESTER_COMPANY = "REQUESTER_COMPANY",
  SUPPLIER_COMPANY = "SUPPLIER_COMPANY",
}

export enum OrderStatus {
  PENDING = "PENDING",
  ORDER_CONFIRMED = "ORDER_CONFIRMED",
  DELIVERY_DATE_PROPOSED = "DELIVERY_DATE_PROPOSED",
  DELIVERY_DATE_CONFIRMED = "DELIVERY_DATE_CONFIRMED",
  DELIVERED = "DELIVERED",
  CANCELLED_BY_SUPPLIER = "CANCELLED_BY_SUPPLIER",
  CANCELLED_BY_REQUESTER = "CANCELLED_BY_REQUESTER",
  DEACTIVATED = "DEACTIVATED",
}

export interface OrderStatusUpdateDTO {
  targetStatus: OrderStatus;
}

/** Stored view state of one order overview variant */
export interface OrderTableViewStateDTO {
  /**
   * Company the result is restricted to. Effective for operators in the INTERNAL and EXTERNAL variants only; has no effect in the platform-wide NEUTRAL view. Every other caller is restricted to its own company.
   * @format int64
   */
  companyId?: number;
  /**
   * Earliest accepted confirmed delivery date
   * @format date
   */
  confirmedDeliveryDateFrom?: string;
  /**
   * Latest accepted confirmed delivery date
   * @format date
   */
  confirmedDeliveryDateTo?: string;
  /**
   * Substring compared against the delivery address' street, house number, postal code and city separately
   * @minLength 0
   * @maxLength 150
   */
  deliveryAddressContains?: string;
  /** True requires an unread ONE_TO_ONE chat message of the logged-in user (System-Chat excluded), false requires none, omitted means no restriction */
  hasUnreadMessages?: boolean;
  /**
   * Substring of the order number
   * @minLength 0
   * @maxLength 150
   */
  orderNumberContains?: string;
  /**
   * Selected order statuses. An empty list is a selection of nothing; a missing list means the selection was never touched.
   * @maxItems 500
   * @minItems 0
   */
  orderStatuses?: OrderStatus[];
  /**
   * Start of the window the planned delivery period must overlap
   * @format date
   */
  plannedDeliveryFrom?: string;
  /**
   * End of the window the planned delivery period must overlap
   * @format date
   */
  plannedDeliveryTo?: string;
  /**
   * Substring of the composed quote number
   * @minLength 0
   * @maxLength 150
   */
  quoteNumberContains?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 50
   */
  size?: number;
}

export interface Pageable {
  /**
   * @format int32
   * @min 0
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   */
  size?: number;
  sort?: string[];
}

export enum PalletType {
  EURO_PALLET_NEW = "EURO_PALLET_NEW",
  EURO_PALLET_NW = "EURO_PALLET_NW",
  EURO_PALLET_USED = "EURO_PALLET_USED",
  INDUSTRY_PALLET = "INDUSTRY_PALLET",
  ONE_WAY_PALLET = "ONE_WAY_PALLET",
  EURO_PALLET_ONE_WAY = "EURO_PALLET_ONE_WAY",
  INDUSTRY_PALLET_ONE_WAY = "INDUSTRY_PALLET_ONE_WAY",
}

export interface PlantDTO {
  /** @format int32 */
  annualProductionTonnes?: number;
  /** @format int32 */
  commissionedYear: number;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /** @format int32 */
  decommissionedYear?: number;
  /** @format int64 */
  id?: number;
  /**
   * @minLength 0
   * @maxLength 100
   */
  location: string;
  /**
   * @minLength 0
   * @maxLength 10
   */
  name: string;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export enum PrintType {
  NO_PRINT = "NO_PRINT",
  FULL_AREA_PRINT = "FULL_AREA_PRINT",
  WARNING_PRINT = "WARNING_PRINT",
}

export interface QuantityOptionDTO {
  /**
   * @min 0.01
   * @max 10000000
   */
  netPricePer1000?: number;
  netPriceTotal?: number;
  /**
   * @format int32
   * @min 1
   * @max 10000000
   */
  quantity: number;
}

export interface QuoteDTO {
  /**
   * @minLength 0
   * @maxLength 500
   */
  additionalInformation?: string;
  company: CompanyDisplayDTO;
  contactPerson: UserDisplayDTO;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /**
   * @minLength 1
   * @maxLength 50
   */
  customerReferenceNumber?: string;
  declineReason?: DeclineReason;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  feedback?: string;
  /** @format int64 */
  id?: number;
  orderData: OrderDataDTO;
  orderDocuments?: OrderDocumentsDTO;
  /** @format int32 */
  quoteVersion?: number;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  rejectionReason?: string;
  requestDisplay: RequestDisplayDTO;
  status: QuoteStatus;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format date */
  validUntil?: string;
  /** @format int32 */
  version?: number;
  withdrawnAfterSubmission?: boolean;
}

export interface QuoteDetailDTO {
  quoteCustomerReferenceNumber?: string;
  /** @format int64 */
  quoteId?: number;
  /** @format int32 */
  quoteVersion?: number;
  requestCustomerReferenceNumber?: string;
  status?: QuoteStatus;
  /** @format date */
  statusDate?: string;
  /** @format int64 */
  supplierCompanyId?: number;
  supplierCompanyName?: string;
}

export enum QuoteStatus {
  NOT_VACANT = "NOT_VACANT",
  VACANT = "VACANT",
  SUBMITTED = "SUBMITTED",
  ACCEPTED = "ACCEPTED",
  DISMISSED = "DISMISSED",
  REJECTED = "REJECTED",
  IN_NEGOTIATION = "IN_NEGOTIATION",
}

export interface QuoteStatusByCompanyDTO {
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  /** @format int64 */
  count?: number;
  status?: QuoteStatus;
}

export interface QuoteSupplierRequesterDTO {
  quoteCustomerReferenceNumber?: string;
  quoteStatus?: QuoteStatus;
  requestCustomerReferenceNumber?: string;
  /** @format int64 */
  requesterCompanyId?: number;
  requesterCompanyName?: string;
  /** @format date */
  statusDate?: string;
  /** @format int64 */
  supplierCompanyId?: number;
  supplierCompanyName?: string;
}

export interface QuoteTerminationParamsDTO {
  /** @format date */
  requestExecDate?: string;
}

export interface QuoteValidationParamsDTO {
  /** @format date */
  deliveryDateFromQuote?: string;
  /** @format date */
  deliveryDateFromRequest?: string;
  /** @format date */
  deliveryDateToQuote?: string;
  /** @format date */
  deliveryDateToRequest?: string;
  /** @format date */
  validUntilQuote?: string;
  /** @format date */
  validUntilRequest?: string;
}

export interface QuotesByCompanyDTO {
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  /** @format int64 */
  quoteCount?: number;
}

export interface QuotesByMonthDTO {
  /** @format int32 */
  month?: number;
  /** @format int64 */
  quoteCount?: number;
  /** @format int32 */
  year?: number;
}

export enum RecipientCandidateSort {
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
}

/** A company in a request's recipient scope, for read-only display */
export interface RecipientCompanyDTO {
  /**
   * Recipient company id
   * @format int64
   */
  id?: number;
  /** Recipient company name */
  name?: string;
}

/** Recipient scope of a request for read-only display */
export interface RecipientScopeDTO {
  /** Selected companies; empty for mode ALL */
  companies?: RecipientCompanyDTO[];
  /** Recipient scope mode */
  mode?: RequestRecipientMode;
}

/** Recipient selection for a publication call: either every eligible company, or a fixed set of companies */
export interface RecipientSelectionDTO {
  /**
   * Ids of the selected companies; only meaningful for mode SELECTED
   * @maxItems 1000
   * @minItems 0
   * @uniqueItems true
   */
  companyIds?: number[];
  /** Recipient scope mode; null normalizes to ALL only when companyIds is empty */
  mode?: RequestRecipientMode;
}

export enum RequestActions {
  UPDATE_REQUEST = "UPDATE_REQUEST",
  DELETE_REQUEST = "DELETE_REQUEST",
  PUBLISH_REQUEST = "PUBLISH_REQUEST",
  UNPUBLISH_REQUEST = "UNPUBLISH_REQUEST",
  CANCEL_REQUEST = "CANCEL_REQUEST",
  CANCEL_PREVIOUSLY_PUBLISHED_REQUEST = "CANCEL_PREVIOUSLY_PUBLISHED_REQUEST",
  CONFIRM_QUOTE = "CONFIRM_QUOTE",
  CONFIRM_REQUEST_INTERNALLY = "CONFIRM_REQUEST_INTERNALLY",
  BID_FOR_REQUEST = "BID_FOR_REQUEST",
  WITHDRAW_QUOTE = "WITHDRAW_QUOTE",
  REJECT_REQUEST = "REJECT_REQUEST",
  REVOKE_REJECTED_QUOTE = "REVOKE_REJECTED_QUOTE",
  GIVE_FEEDBACK = "GIVE_FEEDBACK",
  SUBMIT_REVISED_BID = "SUBMIT_REVISED_BID",
  ANSWER_IN_CHAT = "ANSWER_IN_CHAT",
  ASK_IN_CHAT = "ASK_IN_CHAT",
  EXTEND_DATES = "EXTEND_DATES",
  UPDATE_ADDITIONAL_INFORMATION = "UPDATE_ADDITIONAL_INFORMATION",
}

export interface RequestDTO {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  additionalInformation?: string;
  /** @uniqueItems true */
  allowedActions?: RequestActions[];
  /**
   * @minLength 1
   * @maxLength 50
   */
  boxhubNumber?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  cancellationReason?: string;
  clonedBoxhubNumber?: string;
  company: CompanyDisplayDTO;
  contactPerson: UserDisplayDTO;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /**
   * @minLength 1
   * @maxLength 50
   */
  customerReferenceNumber?: string;
  deliveryAddress: AddressDTO;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  feedbackFreeText?: string;
  feedbackReason?: DeclineReason;
  hideDeliveryAddress?: boolean;
  /** @format int64 */
  id?: number;
  internalConfirmationBy?: UserDisplayDTO;
  /** @format date */
  internalConfirmationDate?: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  internalConfirmationReason?: string;
  order?: OrderDTO;
  orderData: OrderDataDTO;
  orderDocuments: OrderDocumentsDTO;
  /** @format date-time */
  publishedAt?: string;
  quotes?: QuoteDTO[];
  /** Recipient scope of a request for read-only display */
  recipientScope?: RecipientScopeDTO;
  /** Recipient selection for a publication call: either every eligible company, or a fixed set of companies */
  recipientSelection?: RecipientSelectionDTO;
  status: RequestStatus;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format date */
  validUntil?: string;
  /** @format int32 */
  version?: number;
}

export interface RequestDetailDTO {
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  customerReferenceNumber?: string;
  /** @format date-time */
  publishedAt?: string;
  /** @format int64 */
  requestId?: number;
  status?: RequestStatus;
}

export interface RequestDisplayDTO {
  additionalInformation?: string;
  boxhubNumber?: string;
  company?: CompanyDisplayDTO;
  /** @format date */
  confirmationDeadline?: string;
  contactPerson?: UserDisplayDTO;
  customerReferenceNumber?: string;
  deliveryAddress?: AddressDTO;
  /** @format date */
  deliveryDateFrom?: string;
  /** @format date */
  deliveryDateTo?: string;
  deliveryDistanceStatus?: CalculationStatus;
  directionToRequester?: CardinalDirection;
  /** @format int32 */
  distanceMeters?: number;
  hasBluePrints?: boolean;
  hasPrintImages?: boolean;
  hideDeliveryAddress?: boolean;
  /** @format int64 */
  id?: number;
  orderData?: OrderDataDTO;
  quoteStatus?: QuoteStatus;
  /** @uniqueItems true */
  requestActions?: RequestActions[];
  requestStatus?: RequestStatus;
  /** @format date */
  submissionDeadline?: string;
  /** @format int32 */
  submittedQuoteCount?: number;
  /** @format date */
  validUntil?: string;
}

/** A feedback marker, as returned after it has been answered */
export interface RequestFeedbackDTO {
  /**
   * Feedback marker ID
   * @format int64
   */
  feedbackId?: number;
  /** Optional free text given by the answering company */
  freeText?: string;
  /** Reason given by the answering company */
  reason?: DeclineReason;
  /**
   * Request ID
   * @format int64
   */
  requestId?: number;
  /** Marker status */
  status?: RequestFeedbackStatus;
}

export enum RequestFeedbackStatus {
  PENDING = "PENDING",
  ANSWERED = "ANSWERED",
}

export enum RequestFilter {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export interface RequestOverviewRowDTO {
  additionalInformation?: string;
  boxhubNumber?: string;
  cartonGrade?: CartonGradeDTO;
  company?: CompanyDisplayDTO;
  contactPerson?: UserDisplayDTO;
  customerReferenceNumber?: string;
  dangerousGoods?: boolean;
  deliveryAddress?: AddressDisplayDTO;
  /** @format date */
  deliveryDateFrom?: string;
  /** @format date */
  deliveryDateTo?: string;
  deliveryDistanceStatus?: CalculationStatus;
  directionToRequester?: CardinalDirection;
  /** @format int32 */
  distanceMeters?: number;
  /** @format int32 */
  externalNumberOfColors?: number;
  externalPrint?: PrintType;
  fefcoCode?: string;
  hasBluePrints?: boolean;
  hasPrintImages?: boolean;
  hideDeliveryAddress?: boolean;
  /** @format int64 */
  id?: number;
  internalDimension?: DimensionDTO;
  /** @format int32 */
  internalNumberOfColors?: number;
  internalPrint?: PrintType;
  /** @format int32 */
  oneToOneUnreadCount?: number;
  /** @format date-time */
  publishedAt?: string;
  quantityOptions?: QuantityOptionDTO[];
  quoteStatus?: QuoteStatus;
  /** @uniqueItems true */
  requestActions?: RequestActions[];
  requestStatus?: RequestStatus;
  /** @format int32 */
  submittedQuoteCount?: number;
  /** @format date */
  validUntil?: string;
}

/** A whitelisted, active recipient candidate for a request, with distance to the delivery address */
export interface RequestRecipientCandidateDTO {
  /**
   * Candidate company id
   * @format int64
   */
  companyId?: number;
  /** Candidate company name */
  companyName?: string;
  /**
   * Distance in kilometers from the candidate's company address to the request's delivery address; null when unavailable
   * @format int32
   */
  distanceKm?: number;
}

/** Paged result of recipient candidates for a request */
export interface RequestRecipientCandidatePageDTO {
  /** Candidates on the current page */
  candidates?: RequestRecipientCandidateDTO[];
  /**
   * Current page, zero-based
   * @format int32
   */
  page?: number;
  /**
   * Number of items per page
   * @format int32
   */
  size?: number;
  /**
   * Total number of matching candidates
   * @format int64
   */
  totalElements?: number;
  /**
   * Total number of pages
   * @format int32
   */
  totalPages?: number;
}

export enum RequestRecipientMode {
  ALL = "ALL",
  SELECTED = "SELECTED",
}

/** Search parameters for the paged request overview */
export interface RequestSearchParamsDTO {
  /**
   * Carton grade code prefix to restrict the result to. Blank means no restriction.
   * @minLength 0
   * @maxLength 150
   */
  cartonGradeStartsWith?: string;
  /**
   * Substring of the composed customer number
   * @minLength 0
   * @maxLength 150
   */
  customerNumberContains?: string;
  /**
   * Start of the delivery window the request's delivery period must overlap
   * @format date
   */
  deliveryDateFrom?: string;
  /**
   * End of the delivery window the request's delivery period must overlap
   * @format date
   */
  deliveryDateTo?: string;
  /**
   * Largest accepted distance in kilometres; supplier view only. Rows without a calculated distance stay visible.
   * @format int32
   * @min 0
   * @max 20000
   */
  distanceKmMax?: number;
  /**
   * Smallest accepted distance in kilometres; supplier view only. Rows without a calculated distance stay visible.
   * @format int32
   * @min 0
   * @max 20000
   */
  distanceKmMin?: number;
  /**
   * FEFCO code prefix to restrict the result to. Blank means no restriction.
   * @minLength 0
   * @maxLength 150
   */
  fefcoCodeStartsWith?: string;
  /** True requires a blueprint, false requires none, omitted means no restriction */
  hasBluePrints?: boolean;
  /** True requires a print image, false requires none, omitted means no restriction */
  hasPrintImages?: boolean;
  /** True requires an unread ONE_TO_ONE chat message of the logged-in user (System-Chat excluded), false requires none, omitted means no restriction. An Innendienst-Mitarbeiter never has unread messages, so true returns nothing for that caller. */
  hasUnreadMessages?: boolean;
  /**
   * Largest accepted internal height in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionHeightMax?: number;
  /**
   * Smallest accepted internal height in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionHeightMin?: number;
  /**
   * Largest accepted internal length in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionLengthMax?: number;
  /**
   * Smallest accepted internal length in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionLengthMin?: number;
  /**
   * Largest accepted internal width in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionWidthMax?: number;
  /**
   * Smallest accepted internal width in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionWidthMin?: number;
  /** True requires a carton grade whose code exists in the ProGroup catalog, false requires one that does not (including a request without any carton grade code), omitted means no restriction */
  isProGroupCartonGrade?: boolean;
  /**
   * Largest accepted net price per 1000 pieces; evaluated independently of the quantity range
   * @min 0
   * @max 10000000
   */
  netPriceMax?: number;
  /**
   * Smallest accepted net price per 1000 pieces; evaluated independently of the quantity range
   * @min 0
   * @max 10000000
   */
  netPriceMin?: number;
  /**
   * Zero-based page index
   * @format int32
   * @min 0
   * @default 0
   */
  page?: number;
  /**
   * Largest accepted quantity; a request matches when at least one of its quantity steps lies in the range
   * @format int32
   * @min 0
   * @max 10000000
   */
  quantityMax?: number;
  /**
   * Smallest accepted quantity; a request matches when at least one of its quantity steps lies in the range
   * @format int32
   * @min 0
   * @max 10000000
   */
  quantityMin?: number;
  /**
   * Selected quote statuses. An empty list is a selection of nothing and yields an empty result; it does not mean all statuses.
   * @maxItems 500
   * @minItems 0
   */
  quoteStatuses?: QuoteStatus[];
  /**
   * Selected request statuses. An empty list is a selection of nothing and yields an empty result; it does not mean all statuses.
   * @maxItems 500
   * @minItems 0
   */
  requestStatuses?: RequestStatus[];
  /**
   * Substring of the requesting company's name
   * @minLength 0
   * @maxLength 150
   */
  requesterCompanyContains?: string;
  /**
   * Free-text search over customer number, requesting company, carton grade code and FEFCO code
   * @minLength 0
   * @maxLength 150
   */
  searchText?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 50
   * @default 25
   */
  size?: number;
  /**
   * Sort direction. It takes effect together with a picked sortField only; without a column the fixed default order applies and the direction is ignored.
   * @default "DESC"
   */
  sortDirection?: RequestSortDirection;
  /** Column to sort by. Omitting the field yields the default order: in the internal view the not-yet-published requests first, then the active ones, then the cancelled and deactivated ones, each group ordered by validity date descending with requests without a validity date first; the supplier view keeps just the validity date order without the group. Sending VALID_UNTIL explicitly is the user-picked column sort instead, which places requests without a validity date last in both directions and applies to every view alike. */
  sortField?: RequestSortField;
  /**
   * Largest accepted total price of a quantity step; evaluated independently of the other two ranges
   * @min 0
   * @max 100000000000
   */
  totalPriceMax?: number;
  /**
   * Smallest accepted total price of a quantity step; evaluated independently of the other two ranges
   * @min 0
   * @max 100000000000
   */
  totalPriceMin?: number;
  /** Internal (own requests) or external (supplier view) search */
  type: RequestFilter;
  /**
   * Earliest accepted validity date
   * @format date
   */
  validUntilFrom?: string;
  /**
   * Latest accepted validity date
   * @format date
   */
  validUntilTo?: string;
}

/** One page of the request overview including the total hit count */
export interface RequestSearchResultDTO {
  /**
   * Zero-based index of the returned page
   * @format int32
   */
  page?: number;
  /** Rows of the returned page */
  rows?: RequestOverviewRowDTO[];
  /**
   * Requested page size
   * @format int32
   */
  size?: number;
  /**
   * Number of hits across all pages
   * @format int64
   */
  totalElements?: number;
  /**
   * Number of pages for the current page size
   * @format int32
   */
  totalPages?: number;
  /**
   * Sum of unread messages over the whole filtered set, not just the returned page
   * @format int32
   */
  totalUnreadMessages?: number;
}

export enum RequestSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum RequestSortField {
  CUSTOMER_REQUEST_NUMBER = "CUSTOMER_REQUEST_NUMBER",
  REQUESTER_COMPANY = "REQUESTER_COMPANY",
  STATUS = "STATUS",
  VALID_UNTIL = "VALID_UNTIL",
  DISTANCE = "DISTANCE",
  DELIVERY_DATE = "DELIVERY_DATE",
  CARTON_GRADE = "CARTON_GRADE",
  FEFCO_CODE = "FEFCO_CODE",
  INTERNAL_DIMENSIONS = "INTERNAL_DIMENSIONS",
  QUANTITY = "QUANTITY",
  NET_PRICE = "NET_PRICE",
  TOTAL_PRICE = "TOTAL_PRICE",
  PUBLISHED_AT = "PUBLISHED_AT",
}

export enum RequestStatus {
  DRAFT = "DRAFT",
  CREATED = "CREATED",
  PUBLISHED = "PUBLISHED",
  TO_BE_CONFIRMED = "TO_BE_CONFIRMED",
  CONFIRMED = "CONFIRMED",
  CANCELLED = "CANCELLED",
  DEACTIVATED = "DEACTIVATED",
  IN_NEGOTIATION = "IN_NEGOTIATION",
}

export interface RequestStatusByCompanyDTO {
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  /** @format int64 */
  count?: number;
  status?: RequestStatus;
}

/** Stored view state of one request overview variant */
export interface RequestTableViewStateDTO {
  /**
   * Carton grade code prefix the result is restricted to
   * @minLength 0
   * @maxLength 150
   */
  cartonGradeStartsWith?: string;
  /**
   * Substring of the composed customer number
   * @minLength 0
   * @maxLength 150
   */
  customerNumberContains?: string;
  /**
   * Start of the delivery window the request's delivery period must overlap
   * @format date
   */
  deliveryDateFrom?: string;
  /**
   * End of the delivery window the request's delivery period must overlap
   * @format date
   */
  deliveryDateTo?: string;
  /**
   * Largest accepted distance in kilometres; supplier view only
   * @format int32
   * @min 0
   * @max 20000
   */
  distanceKmMax?: number;
  /**
   * Smallest accepted distance in kilometres; supplier view only
   * @format int32
   * @min 0
   * @max 20000
   */
  distanceKmMin?: number;
  /**
   * FEFCO code prefix the result is restricted to
   * @minLength 0
   * @maxLength 150
   */
  fefcoCodeStartsWith?: string;
  /** True requires a blueprint, false requires none, omitted means no restriction */
  hasBluePrints?: boolean;
  /** True requires a print image, false requires none, omitted means no restriction */
  hasPrintImages?: boolean;
  /** True requires an unread ONE_TO_ONE chat message of the logged-in user (System-Chat excluded), false requires none, omitted means no restriction */
  hasUnreadMessages?: boolean;
  /**
   * Largest accepted internal height in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionHeightMax?: number;
  /**
   * Smallest accepted internal height in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionHeightMin?: number;
  /**
   * Largest accepted internal length in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionLengthMax?: number;
  /**
   * Smallest accepted internal length in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionLengthMin?: number;
  /**
   * Largest accepted internal width in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionWidthMax?: number;
  /**
   * Smallest accepted internal width in mm
   * @format int32
   * @min 0
   * @max 5000
   */
  internalDimensionWidthMin?: number;
  /** True requires a carton grade whose code exists in the ProGroup catalog, false requires one that does not (including a request without any carton grade code), omitted means no restriction */
  isProGroupCartonGrade?: boolean;
  /**
   * Largest accepted net price per 1000 pieces
   * @min 0
   * @max 10000000
   */
  netPriceMax?: number;
  /**
   * Smallest accepted net price per 1000 pieces
   * @min 0
   * @max 10000000
   */
  netPriceMin?: number;
  /**
   * Largest accepted quantity of a quantity step
   * @format int32
   * @min 0
   * @max 10000000
   */
  quantityMax?: number;
  /**
   * Smallest accepted quantity of a quantity step
   * @format int32
   * @min 0
   * @max 10000000
   */
  quantityMin?: number;
  /**
   * Selected quote statuses. An empty list is a selection of nothing; a missing list means the selection was never touched.
   * @maxItems 500
   * @minItems 0
   */
  quoteStatuses?: QuoteStatus[];
  /**
   * Selected request statuses. An empty list is a selection of nothing; a missing list means the selection was never touched.
   * @maxItems 500
   * @minItems 0
   */
  requestStatuses?: RequestStatus[];
  /**
   * Substring of the requesting company's name
   * @minLength 0
   * @maxLength 150
   */
  requesterCompanyContains?: string;
  /**
   * Page size
   * @format int32
   * @min 1
   * @max 50
   */
  size?: number;
  /**
   * Largest accepted total price of a quantity step
   * @min 0
   * @max 100000000000
   */
  totalPriceMax?: number;
  /**
   * Smallest accepted total price of a quantity step
   * @min 0
   * @max 100000000000
   */
  totalPriceMin?: number;
  /**
   * Earliest accepted validity date
   * @format date
   */
  validUntilFrom?: string;
  /**
   * Latest accepted validity date
   * @format date
   */
  validUntilTo?: string;
}

export interface RequestValidationParamsDTO {
  /** @format date */
  deliveryDateFrom?: string;
  /** @format date */
  deliveryDateTo?: string;
  /** @format date */
  validUntil?: string;
}

export interface RequestsByCompanyDTO {
  /** @format int64 */
  companyId?: number;
  companyName?: string;
  /** @format int64 */
  requestCount?: number;
}

export interface RequestsByMonthDTO {
  /** @format int32 */
  month?: number;
  /** @format int64 */
  requestCount?: number;
  /** @format int32 */
  year?: number;
}

export enum Salutation {
  MR = "MR",
  MS = "MS",
  DR_MALE = "DR_MALE",
  DR_FEMALE = "DR_FEMALE",
  PROF_MALE = "PROF_MALE",
  PROF_FEMALE = "PROF_FEMALE",
  DIVERS = "DIVERS",
}

export interface SearchResultCompanyOverviewRowDTO {
  limited?: boolean;
  rows?: CompanyOverviewRowDTO[];
}

export interface ServerInfoDTO {
  activeProfiles?: string[];
  baseUrl?: string;
  buildNumber?: string;
  environmentName?: string;
  environmentVariables?: Record<string, string>;
  hostName?: string;
  version?: string;
}

export interface SessionDTO {
  admin?: boolean;
  buildNumber?: string;
  company?: CompanyDisplayDTO;
  /** @format int32 */
  displacementDays?: number;
  environment?: string;
  /** @format int64 */
  id?: number;
  language?: Language;
  otherCompanyMemberships?: CompanyDisplayDTO[];
  roles?: UserRoleType[];
  serverVersion?: string;
  tenant?: TenantDisplayDTO;
  user?: UserDisplayDTO;
}

export interface SignInDTO {
  /**
   * @minLength 4
   * @maxLength 320
   * @pattern ^[a-zA-Z0-9_%+-](?:[a-zA-Z0-9_%+-]|\.(?=[a-zA-Z0-9_%+-]))*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$
   */
  email: string;
  password: string;
  recaptchaToken?: string;
}

/** A status hint displayed inline in the chat timeline, projected from request events */
export interface StatusPillDTO {
  actorIsCurrentCompany?: boolean;
  boxhubNumber?: string;
  companyName?: string;
  /** @format date */
  deliveryDate?: string;
  kind?: string;
  targetOrderStatus?: OrderStatus;
  /** @format date-time */
  timestamp?: string;
  viewerIsRequester?: boolean;
}

export type StatusPillEntry = ChatTimelineEntryDTO & {
  /** A status hint displayed inline in the chat timeline, projected from request events */
  pill?: StatusPillDTO;
};

export interface TenantDTO {
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  /** @format int64 */
  id?: number;
  /** List of member companies belonging to the tenant */
  members?: any[] | null;
  /**
   * Name of the tenant
   * @example "Holding"
   */
  name?: string | null;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export interface TenantDisplayDTO {
  /** @format int64 */
  id?: number;
  /**
   * Name of the tenant
   * @example "Holding"
   */
  name?: string;
}

export enum TerminationSource {
  OPERATOR = "OPERATOR",
  CLIENT = "CLIENT",
}

export interface TimeControlDTO {
  /** @format int32 */
  displacement?: number;
  /** @format date */
  today?: string;
}

/** Unread message counts for a conversation */
export interface UnreadCountDTO {
  /** @format int32 */
  oneToOneCount?: number;
  /** @format int32 */
  systemCount?: number;
  /** @format int32 */
  total?: number;
}

export interface UpdateAdditionalInformationDTO {
  /**
   * @minLength 0
   * @maxLength 4000
   */
  additionalInformation?: string;
}

export enum UserActions {
  DELETE = "DELETE",
  PASSWORD_RESET = "PASSWORD_RESET",
  RESEND_INVITATION = "RESEND_INVITATION",
  CHANGE_EMAIL = "CHANGE_EMAIL",
  GENERATE_USER_SIGNUP_LINK = "GENERATE_USER_SIGNUP_LINK",
  GENERATE_PASSWORD_RESET_LINK = "GENERATE_PASSWORD_RESET_LINK",
}

export interface UserDTO {
  /** Reason of lock */
  accessLock?: AccessLockDTO;
  /** @uniqueItems true */
  allowedActions?: UserActions[];
  /** @format date */
  apiTokenExpirationDate?: string;
  company?: CompanyDisplayDTO;
  /** @format date-time */
  createdAt?: string;
  createdBy?: UserDisplayDTO;
  email?: string;
  fax?: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  firstName: string;
  /** @format int64 */
  id?: number;
  invitation?: InvitationInfoDTO;
  language: Language;
  /**
   * @minLength 2
   * @maxLength 100
   */
  lastName: string;
  /** @format int64 */
  membershipId?: number;
  salutation: Salutation;
  status?: CompanyMembershipStatus;
  telephone?: string;
  /** @format date-time */
  updatedAt?: string;
  updatedBy?: UserDisplayDTO;
  /** @format int32 */
  version?: number;
}

export interface UserDisplayDTO {
  email?: string;
  fax?: string;
  firstName?: string;
  /** @format int64 */
  id?: number;
  lastName?: string;
  locked?: boolean;
  salutation?: Salutation;
  status?: CompanyMembershipStatus;
  telephone?: string;
}

export interface UserInvitationDTO {
  /** @format int64 */
  companyId: number;
  /**
   * @minLength 4
   * @maxLength 320
   * @pattern ^[a-zA-Z0-9_%+-](?:[a-zA-Z0-9_%+-]|\.(?=[a-zA-Z0-9_%+-]))*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 6
   * @maxLength 20
   * @pattern ^(?=(?:\D*\d){6,})(?:\+|00)?[1-9]\d{0,2}[-\.\s]?\(?\d+\)?(?:[-\.\s]\(?\d+\)?)*$
   */
  fax?: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  firstName: string;
  language: Language;
  /**
   * @minLength 2
   * @maxLength 100
   */
  lastName: string;
  /**
   * @minLength 6
   * @maxLength 20
   * @pattern ^(?=(?:\D*\d){6,})(?:\+|00)?[1-9]\d{0,2}[-\.\s]?\(?\d+\)?(?:[-\.\s]\(?\d+\)?)*$
   */
  phone: string;
  salutation: Salutation;
}

export interface UserPasswordResetDTO {
  confirmPassword: string;
  /**
   * @minLength 4
   * @maxLength 320
   * @pattern ^[a-zA-Z0-9_%+-](?:[a-zA-Z0-9_%+-]|\.(?=[a-zA-Z0-9_%+-]))*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$
   */
  email: string;
  password: string;
}

export enum UserRoleType {
  OPERATOR = "OPERATOR",
  CLIENT = "CLIENT",
  CLIENT_MANAGING_DIRECTOR = "CLIENT_MANAGING_DIRECTOR",
  OPERATOR_MANAGING_DIRECTOR = "OPERATOR_MANAGING_DIRECTOR",
  SYSTEM = "SYSTEM",
  ADMIN = "ADMIN",
}

export interface UserSetting {
  /** Setting key */
  key: UserSettingKey;
  /**
   * @minLength 0
   * @maxLength 32768
   */
  value: string;
}

/** All allowed user setting keys. */
export enum UserSettingKey {
  EMAIL_NOTIFICATIONS_REQUEST_PUBLISHED_ME = "EMAIL_NOTIFICATIONS_REQUEST_PUBLISHED_ME",
  EMAIL_NOTIFICATIONS_REQUEST_PUBLISHED_COLLEAGUES = "EMAIL_NOTIFICATIONS_REQUEST_PUBLISHED_COLLEAGUES",
  EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_ME = "EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_ME",
  EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_COLLEAGUES = "EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_COLLEAGUES",
  EMAIL_NOTIFICATIONS_INCOMING_QUOTE = "EMAIL_NOTIFICATIONS_INCOMING_QUOTE",
  EMAIL_NOTIFICATIONS_COOP_QUOTE_CONFIRMED_ME = "EMAIL_NOTIFICATIONS_COOP_QUOTE_CONFIRMED_ME",
  EMAIL_NOTIFICATIONS_COOP_QUOTE_CONFIRMED_COLLEAGUES = "EMAIL_NOTIFICATIONS_COOP_QUOTE_CONFIRMED_COLLEAGUES",
  EMAIL_NOTIFICATIONS_REQUEST_REMINDER_BEFORE_DUE = "EMAIL_NOTIFICATIONS_REQUEST_REMINDER_BEFORE_DUE",
  EMAIL_NOTIFICATIONS_REQUEST_DEACTIVATED_AFTER_DUE = "EMAIL_NOTIFICATIONS_REQUEST_DEACTIVATED_AFTER_DUE",
  EMAIL_NOTIFICATIONS_NEW_REQUEST_PUBLISHED = "EMAIL_NOTIFICATIONS_NEW_REQUEST_PUBLISHED",
  EMAIL_NOTIFICATIONS_NEW_REQUEST_PUBLISHED_MAX_DISTANCE_KM = "EMAIL_NOTIFICATIONS_NEW_REQUEST_PUBLISHED_MAX_DISTANCE_KM",
  EMAIL_NOTIFICATIONS_INCOMING_COOP_REQUEST_CONFIRMED_ME = "EMAIL_NOTIFICATIONS_INCOMING_COOP_REQUEST_CONFIRMED_ME",
  EMAIL_NOTIFICATIONS_INCOMING_COOP_REQUEST_CONFIRMED_COLLEAGUES = "EMAIL_NOTIFICATIONS_INCOMING_COOP_REQUEST_CONFIRMED_COLLEAGUES",
  EMAIL_NOTIFICATIONS_YOUR_COOP_QUOTE_ACCEPTED = "EMAIL_NOTIFICATIONS_YOUR_COOP_QUOTE_ACCEPTED",
  EMAIL_NOTIFICATIONS_YOUR_COOP_QUOTE_DECLINED = "EMAIL_NOTIFICATIONS_YOUR_COOP_QUOTE_DECLINED",
  EMAIL_NOTIFICATIONS_QUOTE_DEACTIVATED_AFTER_DUE = "EMAIL_NOTIFICATIONS_QUOTE_DEACTIVATED_AFTER_DUE",
  EMAIL_NOTIFICATIONS_QUOTE_FEEDBACK_RECEIVED = "EMAIL_NOTIFICATIONS_QUOTE_FEEDBACK_RECEIVED",
  EMAIL_NOTIFICATIONS_REVISED_QUOTE_RECEIVED = "EMAIL_NOTIFICATIONS_REVISED_QUOTE_RECEIVED",
  EMAIL_NOTIFICATIONS_REQUEST_DATES_EXTENDED = "EMAIL_NOTIFICATIONS_REQUEST_DATES_EXTENDED",
  EMAIL_NOTIFICATIONS_REQUEST_ADDITIONAL_INFORMATION_UPDATED = "EMAIL_NOTIFICATIONS_REQUEST_ADDITIONAL_INFORMATION_UPDATED",
  EMAIL_NOTIFICATIONS_QUOTE_WITHDRAWN = "EMAIL_NOTIFICATIONS_QUOTE_WITHDRAWN",
  EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_SUPPLIER = "EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_SUPPLIER",
  EMAIL_NOTIFICATIONS_ORDER_STATUS_CHANGED_REQUESTER = "EMAIL_NOTIFICATIONS_ORDER_STATUS_CHANGED_REQUESTER",
  EMAIL_NOTIFICATIONS_ORDER_STATUS_CHANGED_OFFERER = "EMAIL_NOTIFICATIONS_ORDER_STATUS_CHANGED_OFFERER",
  TABLE_VIEW_STATE_REQUESTS_INTERNAL = "TABLE_VIEW_STATE_REQUESTS_INTERNAL",
  TABLE_VIEW_STATE_REQUESTS_EXTERNAL = "TABLE_VIEW_STATE_REQUESTS_EXTERNAL",
  TABLE_VIEW_STATE_ORDERS_INTERNAL = "TABLE_VIEW_STATE_ORDERS_INTERNAL",
  TABLE_VIEW_STATE_ORDERS_EXTERNAL = "TABLE_VIEW_STATE_ORDERS_EXTERNAL",
  TABLE_VIEW_STATE_ORDERS_NEUTRAL = "TABLE_VIEW_STATE_ORDERS_NEUTRAL",
}

export interface UserSettingsResponse {
  effective: Record<string, string>;
  effectiveList: UserSetting[];
}

export interface UserSettingsUpdateRequest {
  settings: Record<string, string>;
}

export interface UserSignUpDTO {
  company?: CompanyDisplayDTO;
  confirmPassword?: string;
  /**
   * @minLength 4
   * @maxLength 320
   * @pattern ^[a-zA-Z0-9_%+-](?:[a-zA-Z0-9_%+-]|\.(?=[a-zA-Z0-9_%+-]))*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$
   */
  email: string;
  /**
   * @minLength 6
   * @maxLength 20
   * @pattern ^(?=(?:\D*\d){6,})(?:\+|00)?[1-9]\d{0,2}[-\.\s]?\(?\d+\)?(?:[-\.\s]\(?\d+\)?)*$
   */
  fax?: string;
  /**
   * @minLength 2
   * @maxLength 50
   */
  firstName: string;
  language: Language;
  /**
   * @minLength 2
   * @maxLength 100
   */
  lastName: string;
  password?: string;
  /**
   * @minLength 6
   * @maxLength 20
   * @pattern ^(?=(?:\D*\d){6,})(?:\+|00)?[1-9]\d{0,2}[-\.\s]?\(?\d+\)?(?:[-\.\s]\(?\d+\)?)*$
   */
  phone: string;
  salutation: Salutation;
  userStatus?: UserStatus;
}

export enum UserStatus {
  INVITED = "INVITED",
  UNCONFIRMED = "UNCONFIRMED",
  CONFIRMED = "CONFIRMED",
  DEACTIVATED = "DEACTIVATED",
  REMOVED = "REMOVED",
}
